import usePrefix from '@/hooks/usePrefix';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { FormControl, InputNumberField } from '@/components/formik-rsuite';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';
import { InputNumberFieldProps, NumType } from '@/components/formik-rsuite/InputNumberField';

export interface CardInputNumberProps {
  /**
   * 编辑状态
   */
  isEdit?: boolean;
  /**
   * true为不可编辑，可废弃，用isEdit=false代替
   */
  notEditable?: boolean;
  /**
   * 是否必填
   */
  required?: boolean;
  /**
   * 输入框前缀
   */
  inputPrefix?: string;
  label?: string;
  /**
   * 与field.name一致
   * - 只读数据中也要传个key，否则accepter报错
   */
  formKey: string;
  /**
   * field.value为空时显示的value，一般用于只读数据
   */
  value?: string | number;
  /**
   * value空值时显示 默认是/
   */
  defaultValue?: string | number;
  /**
   * 输入的数字类型 默认整数
   */
  numType?: NumType;
  /**
   * 最大值
   */
  max?: number;
  /**
   * 最小值
   */
  min?: number;
  /**
   * 输入框前的label
   */
  before?: string;
  /**
   * 输入框后的label
   */
  after?: string;
  /**
   * 输入框宽度占满变为auto
   */
  autoWidth?: boolean;
  /**
   * label部分的flex占比
   */
  labelWeight?: number;
  /**
   * content部分的flex占比
   */
  contentWeight?: number;
}

const BicesterCardInputNumber = ({
  className,
  isEdit = true,
  notEditable = false,
  required = false,
  inputPrefix,
  label,
  formKey,
  value,
  defaultValue = FORM_DEFAULT_DISPLAY,
  numType = 'int',
  max = Infinity,
  min = -Infinity,
  before,
  after,
  autoWidth = false,
  labelWeight,
  contentWeight,
  ...props
}: CardInputNumberProps & Omit<InputNumberFieldProps, 'form'>) => {
  const { prefix, classname } = usePrefix('bicester-card-item');

  return (
    <div className={`bicester-card-item-wrap ${className ?? ''}`}>
      <FormGroup
        className={`${classname} bicester-card-inputnumber ${autoWidth ? 'auto-width' : ''}`}
      >
        {label && (
          <ControlLabel
            className={prefix('label')}
            style={{ ...(labelWeight && { flex: labelWeight }) }}
          >
            <div className={prefix('label-text')}>{label}</div>
            <div
              className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
            ></div>
          </ControlLabel>
        )}
        <div
          className={`${prefix('content-wrap')} ${isEdit ? prefix('content-wrap-isedit') : ''}`}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          {isEdit && !notEditable ? (
            <>
              {before && <span className="mr-[5px]">{before}</span>}
              <FormControl
                className={prefix('content')}
                name={formKey}
                accepter={InputNumberField}
                numType={numType}
                max={max}
                min={min}
                {...props}
              />
              {after && <span className="ml-[5px]">{after}</span>}
            </>
          ) : (
            <FormControl
              name={formKey}
              accepter={({ field }) => {
                const displayValue = field.value || value;
                return (
                  <div className={prefix('content-wrap-text')}>
                    {displayValue ? `${before || ''}${displayValue}${after || ''}` : defaultValue}
                  </div>
                );
              }}
            />
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardInputNumber;
